export const EVENTS: Record<string, string> = {
  DENTIST_ADDED: "dentist added",
  USER_SIGNED_IN: "user signed in",
  USER_SIGNED_UP: "user signed up",
  PAYWALL: "paywall",
  MANUAL_BOOKING_CREATED: "manual booking created",
  CODE_SHARED: "code shared",
};

export const PAYWALL_SOURCES: Record<string, string> = {
  MANUAL_BOOKING: "manual booking",
  TIMELINE: "timeline",
  REQUESTS: "requests",
  PROFILE: "profile",
};
